module.exports = __webpack_public_path__ + "static/media/wave-2.ae9a10da.svg";